module.exports = __webpack_public_path__ + "img/S240.52a33ed9.jpg";